var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pto-view"},[(_vm.employmentId != null)?_c('p-t-o-view-employee',{attrs:{"employment-id":_vm.employmentId}}):(_vm.companyId != null)?_c('p-t-o-view-company',{attrs:{"company-id":_vm.companyId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }